// src/components/admin-tools/AttributeChip.tsx
//
// Chip de atributo clicável (core · admin-only · mcp · companion-only) —
// markup LITERAL do wireframe §13 (.tool-chips .chip [ok|k] [off]):
// toggle DIRETO (sem confirmação); ON = chip colorido (core=ok verde,
// admin-only=k âmbar, demais=neutro), OFF = .off (apagado + line-through).
// CSS: src/styles/wf-tools.css (.tools-chip — porte do .chip do wireframe).

import { cn } from '@/lib/utils';

export function AttributeChip({
  active,
  saving = false,
  onToggle,
  label,
  tone,
}: {
  active: boolean;
  saving?: boolean;
  onToggle: () => void;
  label: string;
  /** Tom do wireframe: 'ok' (verde, core) · 'k' (âmbar, admin-only) · neutro. */
  tone?: 'ok' | 'k';
}) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      disabled={saving}
      aria-pressed={active}
      title={`${label}${active ? ' — ativo (clique pra desligar)' : ' — inativo (clique pra ativar)'}`}
      className={cn('tools-chip', tone, !active && 'off')}
    >
      {label}
    </button>
  );
}
